<template>
<!--    <div class="wrapper">-->
        <div id="testimonials" class="section  section-dark">
<!--            <a name="testimonials"></a>-->
            <div class="container">
                <div class="md-layout" >
                    <div class="md-layout-item md-size-100 text-center">
                         <p class="md-display-1" style="color: white;">
                Более 5000+ пользователей нам доверяют </p>
                        <h4 style="color: white;">
                        Наши клиенты работают по всей территории России, Украины, Белорусии и Казахстана начиная с 2011 года.
                        </h4>
                        <h4 style="color: white;">
                            Несколько отзывов о нашей работе:
                        </h4>

                        <el-carousel
                                indicator-position="none"
                                trigger="click"
                                :interval="5000"
                        >
                            <el-carousel-item>
                                <testimonial-card card-plain>
                                    <div
                                            slot="cardAvatarTop"
                                            class="md-card-avatar mt-0"
                                    >
                                        <a href="javascript:void(0)">
                                            <img
                                                    class="img"
                                                    :src="sectionTestimonials2.testimonials2"
                                            >
                                        </a>
                                    </div>
                                    <template slot="cardContent">
                                        <h5 class="card-description">
                                            "...  Благодаря данному программному продукту работа наших торговых представителей по приему заказов стала более продуктивной и удобной..."
                                        </h5>
                                        <h4 class="card-title">
                                            ОАО Раменский мясокомбинат, г. Раменское
                                        </h4>
                                        <h6 class="card-category text-muted">
                                            <a :href="sectionTestimonials1.testimonials5" target="_blank">оригинал отзыва</a>
                                        </h6>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                    </template>
                                </testimonial-card>
                            </el-carousel-item>
                            <el-carousel-item>
                                <testimonial-card card-plain >
                                    <div
                                            slot="cardAvatarTop"
                                            class="md-card-avatar mt-0"
                                    >
                                            <img
                                                    class="img"
                                                    :src="sectionTestimonials2.testimonials3" style="margin: 0px auto 0;"
                                            >

                                    </div>
                                    <template slot="cardContent">
                                        <h5 class="card-description" >
                                            "...  Не могу не отметить отличную работу отдела технической поддержки. Получаем необходимые рекомендации по использованию
                                            и, при необходимости, изменения в модуле программы в кратчайшие сроки и в полном объеме, как по телефону, так и по электронной почте...
                                             Использование программных продуктов AkiTorg позволило нам: автоматизировать создание, прием и обработку заказов; организовать более эффективную работу торговых представителей; осуществлять контроль посещения торговых точек торговыми представителями."
                                        </h5>
                                        <div>
                                        <h4 class="card-title">
                                           Мясоперерабатывающее предприятие ДЮК, г. Буденовск
                                        </h4>
                                        <h6 class="card-category text-muted">
                                            <a :href="sectionTestimonials1.testimonials3" target="_blank">оригинал отзыва</a>
                                        </h6>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        </div>
                                    </template>
                                </testimonial-card>
                            </el-carousel-item>
                            <el-carousel-item>
                                <testimonial-card card-plain>
                                    <div
                                            slot="cardAvatarTop"
                                            class="md-card-avatar mt-0"
                                    >
                                        <a href="javascript:void(0)">
                                            <img
                                                    class="img"
                                                    :src="sectionTestimonials2.testimonials1"
                                            >
                                        </a>
                                    </div>
                                    <template slot="cardContent">
                                        <h5 class="card-description">
                                            "... На протяжении мовместной работы между нашими компаниями сложились не только  деловые отношения, но и отношения взаимопонимания, взаимовыручки.
                                            Благодаря Вашему профессианолизму, наша компания приобрела новых клиентов и расширила спектр своей деятельности ..."
                                        </h5>
                                        <h4 class="card-title">
                                            ООО Трейд эксперт, г. Москва
                                        </h4>
                                        <h6 class="card-category text-muted">
                                            <a :href="sectionTestimonials1.testimonials4" target="_blank">оригинал отзыва</a>
                                        </h6>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                    </template>
                                </testimonial-card>
                            </el-carousel-item>
                            <el-carousel-item>
                                <testimonial-card card-plain >
                                    <div
                                            slot="cardAvatarTop"
                                            class="md-card-avatar mt-0"
                                    >
                                            <img
                                                    class="img"
                                                    :src="sectionTestimonials2.testimonials4" style="margin: 0px auto 0;"
                                            >

                                    </div>
                                    <template slot="cardContent">
                                        <h5 class="card-description" >
                                            "... Внедрение проекта позволило обеспечить практически мгновенную обработку и сброс заказов на склад с контролем остатка,
                                            ограничения максимального заказа, контролем дебиторской задолженности, просмотром фото товаров ..."
                                        </h5>
                                        <div>
                                        <h4 class="card-title">
                                            Торгово-логистическая компания "Алтима", г. Краснодар
                                        </h4>
                                        <h6 class="card-category text-muted">
                                            <a :href="sectionTestimonials1.testimonials2" target="_blank">оригинал отзыва</a>
                                        </h6>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        </div>
                                    </template>
                                </testimonial-card>
                            </el-carousel-item>
                            <el-carousel-item>
                                <testimonial-card card-plain >
                                    <div
                                            slot="cardAvatarTop"
                                            class="md-card-avatar mt-0"
                                    >
                                            <img
                                                    class="img"
                                                    :src="sectionTestimonials2.testimonials5" style="margin: 0px auto 0;"
                                            >

                                    </div>
                                    <template slot="cardContent">
                                        <h5 class="card-description" >
                                            "... Сотрудники AkiTorg помогли очень быстро перейти на новую схему работы. Адаптировали для нас приложение и проконсультировали в решении
                                            специфичных для нас схем торговли. У торговых представителей не вызвало ниаких трудностей использование программы, интерфейс прост и понятен. Тренинг не требуется..."
                                        </h5>
                                        <div>
                                        <h4 class="card-title">
                                            Торговый дом "Алина", г. Калининград
                                        </h4>
                                        <h6 class="card-category text-muted">
                                            <a :href="sectionTestimonials1.testimonials1" target="_blank">оригинал отзыва</a>
                                        </h6>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        <md-icon class="text-warning">
                                            star
                                        </md-icon>
                                        </div>
                                    </template>
                                </testimonial-card>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
                <a name="price"></a>
            </div>
        </div>
<!--    </div>-->
</template>

<script>
  import { TestimonialCard } from "@/components";

  export default {
    name: "Testimonials",
    components: {
      TestimonialCard
    },
    data() {
      return {
        sectionTestimonials1: {
           testimonials1: require("@/assets/img/reply/pruf/alina.jpg"),
          testimonials2: require("@/assets/img/reply/pruf/altima.png"),
          testimonials3: require("@/assets/img/reply/pruf/duk.jpg"),
          testimonials4: require("@/assets/img/reply/pruf/treid.jpg"),
          testimonials5: require("@/assets/img/reply/pruf/ramen.jpg")
        },
        sectionTestimonials2: {
          testimonials1: require("@/assets/img/reply/texp.png"),
          testimonials2: require("@/assets/img/reply/ramen.png"),
          testimonials3: require("@/assets/img/reply/dyk.png"),
          testimonials4: require("@/assets/img/reply/altima.png"),
          testimonials5: require("@/assets/img/reply/alina.png")
        },
        sectionTestimonials3: {
          testimonials1: require("@/assets/img/reply/texp.png")
        }
      };
    },
    methods: {
      sectionTestimonials(image) {
        return {
          backgroundImage: `url(${image})`
        };
      }
    }
  };
</script>

<style lang="scss">
    .el-carousel__container{
        height: 380px !important;
    }

    @media screen and (max-width: 1280px) {
        .el-carousel__container{
            height: 405px !important;
        }
    }
    @media screen and (max-width: 1200px) {
        .el-carousel__container{
            height: 458px !important;
        }
    }
    @media screen and (max-width: 991px) {
        .el-carousel__container{
            height: 458px !important;
        }
    }
    @media screen and (max-width: 960px) {
        .el-carousel__container{
            height: 458px !important;
        }
    }
    @media screen and (max-width: 768px) {
        .el-carousel__container{
            height: 535px !important;
        }
    }
    @media screen and (max-width: 576px) {
        .el-carousel__container{
            height: 560px !important;
        }
    }
    @media screen and (max-width: 517px) {
        .el-carousel__container{
            height: 586px !important;
        }
    }
    @media screen and (max-width: 450px) {
        .el-carousel__container{
            height: 690px !important;
        }
    }
</style>